import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  pushRecentItem,
  type RecentItem,
} from '../components/dashboard/recent-items';
import { createTenantPersistConfig, PERSIST_STORE_KEYS } from './persist';

type RecentItemsStore = {
  itemsByScope: Record<string, RecentItem[]>;
  recordRecentItem: ({
    scopeKey,
    item,
  }: {
    scopeKey: string;
    item: RecentItem;
  }) => void;
};

const EMPTY_RECENT_ITEMS: RecentItem[] = [];

export const useRecentItemsStore = create<RecentItemsStore>()(
  persist(
    (set) => ({
      itemsByScope: {},
      recordRecentItem: ({ scopeKey, item }) =>
        set((state) => {
          const items = state.itemsByScope[scopeKey] ?? EMPTY_RECENT_ITEMS;
          const [latest] = items;

          if (latest?.key === item.key && latest.tab.title === item.tab.title) {
            return state;
          }

          return {
            itemsByScope: {
              ...state.itemsByScope,
              [scopeKey]: pushRecentItem({ items, item }),
            },
          };
        }),
    }),
    {
      ...createTenantPersistConfig({
        storeKey: PERSIST_STORE_KEYS.recentItems,
      }),
      partialize: (state) => ({ itemsByScope: state.itemsByScope }),
    },
  ),
);

export const useRecentItems = (scopeKey: string | null): RecentItem[] =>
  useRecentItemsStore((state) =>
    scopeKey
      ? (state.itemsByScope[scopeKey] ?? EMPTY_RECENT_ITEMS)
      : EMPTY_RECENT_ITEMS,
  );
